import { tryToNumber } from '@zk/framework-vue';

export const toMinuteUnit = (minute, i18n) => {
  const isEn = i18n.locale === 'en';
  const joinStr = isEn ? ' and ' : ' ';
  // 1分钟以内
  if (minute < 60) {
    return `${minute} ${i18n.tc('valueReachCard.other.min', minute)}`;
  }
  // 按照一天8小时计算，不足一天 || 海外版则显示小时
  if (minute < 60 * 8 || isEn) {
    const hour = Math.floor(minute / 60);
    const min = minute % 60;
    const hourStr = `${hour} ${i18n.tc('valueReachCard.other.hour', hour)}`;
    if (min === 0) {
      return hourStr;
    }
    return `${hourStr}${joinStr}${min} ${i18n.tc('valueReachCard.other.min', min)}`;
  }
  // 超过一天显示天数
  const day = Math.floor(minute / (60 * 8));
  const hour = Math.floor((minute % (60 * 8)) / 60);
  const min = minute % 60;
  const dayStr = `${day} ${i18n.tc('valueReachCard.other.day', day)}`;
  const hourStr = `${hour} ${i18n.tc('valueReachCard.other.hour', hour)}`;
  const minStr = `${min} ${i18n.tc('valueReachCard.other.min', min)}`;
  if (hour === 0 && min === 0) {
    return dayStr;
  }
  if (hour === 0) {
    return `${dayStr}${joinStr}${minStr}`;
  }
  if (min === 0) {
    return `${dayStr}${joinStr}${hourStr}`;
  }
  return `${dayStr}${isEn ? ', ' : ' '}${hourStr}${joinStr}${minStr}`;
};


export const getUnitKey = (unit, msg, i18n, num) => {
  const trainList = [];
  const minList = [];
  const itemList = ['automation', 'slack', 'lark', 'ide', 'work_wechat', 'ding_talk'];

  const keys = {
    coffee: 'valueReachCard.other.cup',
    train: 'valueReachCard.other.time',
    time: 'valueReachCard.other.min',
    item: 'valueReachCard.other.item',
    message: 'valueReachCard.other.message'
  };

  const count = tryToNumber(num);
  const isNumber = !Number.isNaN(count);

  if (msg) {
    const str = trainList.includes(msg.module) ? keys.train :
      minList.includes(msg.module) ? keys.time :
        itemList.includes(msg.module) ? keys.item : '';
    if (str === 'valueReachCard.other.item' || isNumber) {
      if (msg.type === 'pushMsg') {
        return i18n.tc(keys.message, count);
      }
      return i18n.tc(str, count);
    }
    return i18n.t(str);
  }

  if (unit === 'item') {
    return i18n.tc(keys[unit], tryToNumber(num)) || unit;
  }
  if (isNumber) {
    return i18n.tc(keys[unit], count) || unit;
  }
  return i18n.t(keys[unit]) || unit;
};
